const images = {
  logoHorizontalWhite: require('./svgs/logo-horizontal-white.svg'),
  logoHorizontalOrange: require('./svgs/logo-horizontal-orange.svg'),
  digiSign: require('images/svgs/digital-signature.svg'),
  bankAccount: require('images/svgs/bank-account.svg'),
  tax: require('images/svgs/tax.svg'),
  logoTickethossHorizontal: require('./svgs/ticketHossHorizontal.svg'),
  pen: require('./svgs/pen.svg'),
  penBlack: require('./svgs/pen-black.svg'),
  logoVertical: require('./logo-vertical.png'),
  logoKartPassHorizontal: require('./kartpasshorizontal.png'),
  logoKart: require('./KartPassWhite.png'),
  stripe: require('./svgs/stripe.svg'),
  passOut: require('./svgs/pass-out-icon.svg'),
  passOutReturn: require('./svgs/pass-out-return-icon.svg'),
  invalid: require('./svgs/invalid-icon.svg'),
  successCheck: require('./svgs/success-check.svg'),
  ticketHossLogo: require('./svgs/ticketHossLogo.svg'),
  delete: require('./svgs/Delete.svg'),
  video: require('./svgs/video.svg'),
  ticketHossCollapsedLogo: require('./svgs/Ticket Hoss Collapsed Menu Logo.svg'),
  pitpayCollapsedLogo: require('./svgs/Pit Pay Collapsed Menu Logo.svg'),
};

export default images;
